import createImmutableSelector from 'lib/immutable/selector'
import { IProfileLayout } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getProfileLayout = (state: any): IProfileLayout => state.get('profileLayoutReducer')

export const profileLayoutSelector = createImmutableSelector(getProfileLayout, (profileLayout) => profileLayout)
